import { render, staticRenderFns } from "./GzhAssistant.vue?vue&type=template&id=3b44e3c1&scoped=true&"
import script from "./GzhAssistant.vue?vue&type=script&lang=js&"
export * from "./GzhAssistant.vue?vue&type=script&lang=js&"
import style0 from "./GzhAssistant.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./GzhAssistant.vue?vue&type=style&index=1&id=3b44e3c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44e3c1",
  null
  
)

export default component.exports